<ng-container *ngIf="svgIcon">
  <span [innerHTML]="svgIcon" [width]="width" class="d-flex align-items-center"></span>
</ng-container>